import { render, staticRenderFns } from "./payskip.vue?vue&type=template&id=35d2812d&scoped=true"
import script from "./payskip.vue?vue&type=script&lang=js"
export * from "./payskip.vue?vue&type=script&lang=js"
import style0 from "./payskip.vue?vue&type=style&index=0&id=35d2812d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2812d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d2812d')) {
      api.createRecord('35d2812d', component.options)
    } else {
      api.reload('35d2812d', component.options)
    }
    module.hot.accept("./payskip.vue?vue&type=template&id=35d2812d&scoped=true", function () {
      api.rerender('35d2812d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/payskip.vue"
export default component.exports